import { IClientSideLogger, LogLevel } from '@nimbus-library/features/logger/services/client-logger/i-client-side-logger';

export class NoopClientSideLogger implements IClientSideLogger {
  public writeMessage(logLevel: LogLevel, logName: string, message: string): void {
    // noop
  }
  public proxyMessage(logName: string, message: string): void {
    // noop
  }
}
